"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = exports.ContextState = void 0;
const settings_1 = require("../env/settings");
const nexus_model_renderer_1 = require("./nexus-model-renderer");
const nexus_model_loader_1 = require("./nexus-model-loader");
class ContextState {
    constructor() {
        this.currentError = 0;
        this.currentRenderError = 0;
        this.cacheSize = 0;
        // Nodes loading state
        this.nodesLoaded = 0;
        this.nodesPending = 0;
        // Nodes rendering
        this.nodesBlocked = 0;
        this.nodesRendered = 0;
        // Draw size
        this.drawSize = 0;
        this.transferred = 0;
    }
}
exports.ContextState = ContextState;
class Context {
    constructor(gl, models = [], candidates = [], settings = new settings_1.Settings()) {
        this.gl = gl;
        this.models = models;
        this.candidates = candidates;
        this.settings = settings;
        this.state = new ContextState();
        this._frame = 0;
        this._onUpdate = null;
        this.state.currentError = this.settings.targetError;
        this.renderer = new nexus_model_renderer_1.NexusModelRenderer(this);
        this.webGLRendererAttributes = { position: 0, normal: 1, color: 2, uv: 3 };
    }
    set onUpdate(value) {
        this._onUpdate = value;
    }
    get frame() {
        return this._frame;
    }
    get tokenProvider() { return this._tokenProvider; }
    set tokenProvider(tokenProvider) { this._tokenProvider = tokenProvider; }
    /**
     * Call to load model data from the specified url.
     */
    load(url, onLoad) {
        return nexus_model_loader_1.NexusModelLoader.loadModel(url, this).then(model => {
            this.models.push(model);
            if (onLoad) {
                onLoad(model);
            }
            return model;
        });
    }
    /**
     * Updates the point where the camera is relative to the model.
     * Used to compute which nodes should be loaded or removed next.
     */
    updateView(viewport, projection, modelView) {
        this.renderer.updateView(viewport, projection, modelView);
    }
    /**
     * Trigger rendering of models in the current context.
     */
    render() {
        for (const model of this.models) {
            this.renderer.render(model);
        }
    }
    /**
     * Called by model loader when a node has been loaded
     */
    modelStateChanged() {
        if (this._onUpdate) {
            this._onUpdate();
        }
    }
    // noinspection JSUnusedGlobalSymbols
    beginFrame(fps) {
        this._frame++;
        this.candidates = [];
        if (fps && this.settings.targetFps) {
            const r = this.settings.targetFps / fps;
            if (r > 1.1) {
                this.state.currentError *= 1.05;
            }
            if (r < 0.9) {
                this.state.currentError *= 0.95;
            }
            if (this.state.currentError < this.settings.targetError) {
                this.state.currentError = this.settings.targetError;
            }
            if (this.state.currentError > 20) {
                this.state.currentError = 20;
            }
        }
        else {
            this.state.currentError = this.settings.targetError;
        }
        this.state.nodesRendered = 0;
    }
    // noinspection JSUnusedGlobalSymbols
    endFrame() {
        nexus_model_loader_1.NexusModelLoader.updateCache(this);
    }
    updateSettingsChanges() {
        nexus_model_loader_1.NexusModelLoader.updateCache(this, true);
    }
}
exports.Context = Context;
